import { parseErrors } from 'helpers/parseResponseErrors';
import { Toast } from 'helpers/toast';
import { getTaskSmsTemplates } from 'queries';
import { useQuery } from 'react-query';
import { JsonDataItem } from 'types';

function useSmsTemplates() {
  const { data } = useQuery(['sms-templates'], getTaskSmsTemplates, {
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  return { templates: data };
}

export { useSmsTemplates };
